import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

//Components
import Button from "../button";
import EpModal from "../modal";
import CustomGatsbyImage from "../gatsbyImage";

// Styles
import * as styles from "../../components/furtherReadingLinks/furtherReadingLinks.module.scss";
import * as expStyles from "./experience.module.scss";

const ExperienceItems = ({ items }) => {
  const [modal, setModal] = useState({ isOpen: false, richText: [] });

  const onOpenModal = useCallback(
    (richText = []) => setModal({ isOpen: true, richText }),
    []
  );
  const onCloseModal = useCallback(
    () => setModal({ isOpen: false, richText: [] }),
    []
  );

  if (!items.length) return null;

  return (
    <>
      {items.map((item, index) => {
        return (
          <div
            key={index.toString()}
            className={cx(styles.columnsCard, expStyles.card)}
          >
            {(item?.image || item?._rawImage) && (
              <div className={expStyles.logo}>
                <CustomGatsbyImage
                  img={item?.image?.asset || item?._rawImage?.asset}
                />
              </div>
            )}
            <h3>{item.title}</h3>
            <p>{item.subtitle}</p>
            <div onClick={onOpenModal.bind(null, item?._rawText || item?.text)}>
              <Button classNameBtn="raleway-xxs-bold" label="Find out more" />
            </div>
          </div>
        );
      })}
      <EpModal data={modal} onCloseModal={onCloseModal} />
    </>
  );
};

export default ExperienceItems;

ExperienceItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      _rawText: PropTypes.array,
      slug: PropTypes.shape({
        current: PropTypes.string,
      }),
      category: PropTypes.shape({
        title: PropTypes.string,
      }),
    })
  ),
};

ExperienceItems.defaultProps = {
  items: [],
};
